export default function pauseTest() {
  this.pageTimeSpent += Date.now() - this.pageStartTime; //
  clearTimeout(this.testTimeout); // make sure test doesnt skip itself
  clearTimeout(this.pageTimerTimeout); // make sure pageTimer doesnt run
  this.testPaused = true;
  // this.$store.commit('pauseBarMut')
  // this.$emit('pauseTest') < use this to pause test
}
